import animation from 'public/assets/animations/loading-spinner.json';
import Lottie from 'lottie-react';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/material/styles';
export type LottieLoaderProps = {
  sx?: SxProps;
};
export function LottieLoader({ sx }: LottieLoaderProps) {
  return (
    <Box sx={sx}>
      <Lottie animationData={animation} />
    </Box>
  );
}
